var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentQris(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2160.5 821.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#231f20;}.cls-2{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo QRIS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1324.87,
    y: 132.07,
    width: 134.86,
    height: 551.69
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "275.85 0 14.82 0 0 14.43 0 271.35 34.06 271.35 34.06 46.79 47.8 33.37 275.85 33.37 275.85 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1884.65 811.96 2145.75 811.96 2160.5 797.52 2160.5 540.61 2126.43 540.61 2126.43 765.17 2112.7 778.59 1884.65 778.59 1884.65 811.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "439.23 338.45 398.65 338.45 398.65 380.04 398.65 435.75 341.54 435.75 341.54 380.04 398.65 380.04 398.65 338.45 300.95 338.45 300.95 478.12 439.23 478.12 439.23 435.75 439.23 380.04 439.23 338.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "90.8 671.4 101.59 683.82 440.59 683.82 440.59 666.59 440.59 549.97 232.88 549.97 232.88 149.28 232.88 135.54 101.59 135.54 91.5 146.87 90.8 671.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "639.52 135.52 300.98 135.52 300.98 149.25 300.98 272.39 510.79 272.39 510.79 821.37 650.38 821.37 650.38 272.39 650.38 146.85 639.52 135.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M708.94,132.08h558.44V467.91H1034.67l231.15,215.86H1063.07l-224-221.37V683.77H708.94V343.29h409.38V259.64H708.94s.77-127.56,0-127.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2070.36 264.39 2070.36 133.49 1518.98 133.49 1518.98 470.25 1889.96 470.25 1889.96 551.49 1518.98 551.49 1518.98 682.47 2070.36 682.47 2070.36 339.35 1699.46 339.35 1699.46 264.39 2070.36 264.39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentQris);
export default __webpack_public_path__ + "static/media/payment_qris.ff8e84ae7c3626cb4005b4f24462a6a4.svg";
export { ForwardRef as ReactComponent };